const SEARCH_ENDPOINT =
  process.env.NODE_ENV === "development"
    ? "https://dxp-au-search.funnelback.squiz.cloud/s/search.json"
    : "https://www.secvictoria.com.au/_designs/integration/search/help-hub";
const MIN_QUERY_LENGTH = 3;
const DEBOUNCE_MS = 300;
const MAX_RESULTS = 8;

export function helpSearchTypeahead() {
  const searchInput = document.getElementById("help-search-input");
  const searchForm = document.querySelector(".help-search-form");

  if (!searchInput || !searchForm) return;

  const resultsContainer = document.createElement("div");
  resultsContainer.className = "help-search-results hidden";
  resultsContainer.id = "help-search-results";
  searchForm.parentNode.appendChild(resultsContainer);

  let debounceTimer = null;
  let activeRequest = null;
  let currentFocus = -1;
  let noResultsShown = false;

  function showNoResults() {
    noResultsShown = true;
    currentFocus = -1;
    resultsContainer.innerHTML = `<div class="help-search-no-results">No results found</div>`;
    resultsContainer.classList.remove("hidden");
  }

  function renderResults(articles) {
    if (!articles.length) {
      showNoResults();
      return;
    }

    noResultsShown = false;

    currentFocus = -1;
    resultsContainer.innerHTML = articles
      .map((article, index) => {
        const isLast = index === articles.length - 1;
        return `<a
          href="${article.url}"
          class="help-search-result-item${isLast ? " last" : ""}"
          data-title="${article.title}"
        >${article.title}</a>`;
      })
      .join("");

    resultsContainer.classList.remove("hidden");

    resultsContainer.querySelectorAll(".help-search-result-item").forEach((item) => {
      item.addEventListener("click", (e) => {
        e.preventDefault();
        searchInput.value = item.getAttribute("data-title");
        resultsContainer.classList.add("hidden");
        setTimeout(() => (window.location.href = item.href), 100);
      });
    });
  }

  async function fetchResults(query) {
    if (activeRequest) activeRequest.abort();
    activeRequest = new AbortController();

    try {
      const url = `${SEARCH_ENDPOINT}?collection=sio~sp-help-hub&profile=help-hub&query=${encodeURIComponent(query)}*&num_ranks=${MAX_RESULTS}`;

      const res = await fetch(url, { signal: activeRequest.signal });
      if (!res.ok) throw new Error(`Search request failed: ${res.status}`);

      const data = await res.json();
      const results = data?.response?.resultPacket?.results ?? [];

      const articles = results.map((r) => ({
        title: r.title,
        url: r.liveUrl,
      }));

      renderResults(articles);
    } catch (err) {
      if (err.name !== "AbortError") {
        showNoResults();
      }
    }
  }

  function showResults(query) {
    noResultsShown = false;
    if (query.length < MIN_QUERY_LENGTH) {
      resultsContainer.classList.add("hidden");
      return;
    }
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => fetchResults(query), DEBOUNCE_MS);
  }

  searchInput.addEventListener("input", (e) => showResults(e.target.value));

  document.addEventListener("click", (e) => {
    if (!searchForm.parentNode.contains(e.target)) {
      resultsContainer.classList.add("hidden");
    }
  });

  searchForm.addEventListener("submit", (e) => {
    const firstResult = resultsContainer.querySelector(".help-search-result-item");

    if (!resultsContainer.classList.contains("hidden") && firstResult && !noResultsShown) {
      e.preventDefault();
      searchInput.value = firstResult.getAttribute("data-title");
      resultsContainer.classList.add("hidden");
      window.location.href = firstResult.href;
    } else if (searchInput.value.trim().length > 0) {
      e.preventDefault();
      clearTimeout(debounceTimer);
      if (activeRequest) activeRequest.abort();
      showNoResults();
    }
  });

  searchInput.addEventListener("keydown", (e) => {
    const items = resultsContainer.querySelectorAll(".help-search-result-item");

    if (e.key === "ArrowDown") {
      e.preventDefault();
      currentFocus = currentFocus >= items.length - 1 ? 0 : currentFocus + 1;
      setActive(items);
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      currentFocus = currentFocus <= 0 ? items.length - 1 : currentFocus - 1;
      setActive(items);
    } else if (e.key === "Enter" && currentFocus > -1 && items[currentFocus]) {
      e.preventDefault();
      items[currentFocus].click();
    } else if (e.key === "Escape") {
      resultsContainer.classList.add("hidden");
      currentFocus = -1;
    }
  });

  function setActive(items) {
    items.forEach((item) => item.classList.remove("active"));
    if (items[currentFocus]) items[currentFocus].classList.add("active");
  }
}
